import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";
import type { IcmJob } from "@/icm/types";

const JobTotalCol: ColumnDef<IcmJob, unknown> = {
  accessorKey: "job_total",
  header: "Job total",
  meta: { size: "120px" },
  cell: ({ getValue }) => {
    const value = getValue() as number | null;
    return (
      <span className="tabular-nums">
        {value != null ? formatMoney(value.toFixed(2)) : "-"}
      </span>
    );
  },
};

export default JobTotalCol;
